import React, { useCallback, useState } from "react";
import { Button, Flex, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import {
  type DetailedPaymentPrefUnionObjectType,
  type RedactedPaymentPref,
} from "../../common/types";
import * as styles from "./styles_vanilla.css";
import { getPaymentMethodText, getTitle } from "./utils";

export type BasePaymentPrefDisplayProps = {
  paymentPref: DetailedPaymentPrefUnionObjectType | RedactedPaymentPref;
  children?: React.ReactNode;
  displayRevealDetails?: boolean;
  renderDetails: () => JSX.Element;
};

export const BasePaymentPrefDisplay: React.FC<BasePaymentPrefDisplayProps> = ({
  paymentPref,
  children,
  displayRevealDetails,
  renderDetails,
}: BasePaymentPrefDisplayProps) => {
  const [revealDetails, setRevealDetails] = useState(false);
  const paymentMethodText = getPaymentMethodText(paymentPref);
  const title = getTitle(paymentPref);

  const handleRevealDetailsClick = useCallback(() => {
    setRevealDetails((revealDetails) => !revealDetails);
  }, []);

  return (
    <Flex className={styles.paymentBlock} flexDirection="column">
      <Flex flexDirection="column">
        <Flex justifyContent="flex-start" alignItems="center" flexDirection="row">
          <Flex flexWrap="wrap">
            <Text className={styles.title} variant="strong-md">
              {title}
            </Text>
          </Flex>
          {displayRevealDetails && (
            <Button
              icon={revealDetails ? "eye-slash" : "eye"}
              iconVariant="solid"
              variant="link"
              displayAsLink
              className={styles.revealDetailsButton}
              onClick={handleRevealDetailsClick}
              data-testid="reveal-details-button"
            >
              {revealDetails ? "Hide details" : "Reveal details"}
            </Button>
          )}
        </Flex>
        <Flex key="payment-method">
          <Text variant="strong-sm" color={Colors.Neutral900}>
            {paymentMethodText}
          </Text>
        </Flex>
      </Flex>
      {revealDetails && renderDetails()}
      {children}
    </Flex>
  );
};
